import { ActionType } from "model/common";
import {
  HOME_CLEAR_MAINMENU_ACTIVE,
  HOME_SET_MAINMENU_ACTIVE,
  HOME_SET_SUBMENU_OPENED,
} from "./constant";

export const setMainMenuActiveAction = (data: { id: number }) => ({
  type: HOME_SET_MAINMENU_ACTIVE,
  data,
});

export const setSubMenuOpenedAction = (data: { opened: boolean }) => ({
  type: HOME_SET_SUBMENU_OPENED,
  data,
});

export const clearMainMenuActiveAction = () => ({
  type: HOME_CLEAR_MAINMENU_ACTIVE,
});

export type HomeActions = ActionType<typeof setMainMenuActiveAction> &
  ActionType<typeof setSubMenuOpenedAction>;
